export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10777.3b5e1b6b.jpg";